"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRestClient = void 0;
const axios_1 = require("axios");
const default_api_1 = require("../api/default-api");
const configuration_1 = require("../configuration");
const axios_auth_refresh_1 = require("./axios-auth-refresh");
const axios_cache_adapter_1 = require("axios-cache-adapter");
/**
 * Used to get an authenticated rest client. If a request fails due to auth, it will call `getAccessToken` and use the result of that to retry the request.
 *
 * @param basePath - base url for api, eg https://api.mandolin.com
 * @param getAccessToken - a function (async or not) that returns an access token. Should handle getting new tokens as needed.
 * @param configurationParameters - API Configuration object
 */
function makeRestClient(basePath, getAccessToken = () => undefined, passedConfigurationParams = {}, { cacheMaxAgeS } = { cacheMaxAgeS: 0 }) {
    let adapter;
    if (cacheMaxAgeS > 0) {
        const cache = axios_cache_adapter_1.setupCache({
            maxAge: cacheMaxAgeS * 1000,
            exclude: {
                query: false,
            },
        });
        adapter = cache.adapter;
    }
    const axiosApiInstance = axios_1.default.create({
        adapter,
    });
    let cachedToken;
    const configurationParams = Object.assign(Object.assign({}, passedConfigurationParams), { accessToken: () => __awaiter(this, void 0, void 0, function* () {
            if (cachedToken) {
                return cachedToken;
            }
            cachedToken = (yield getAccessToken()) || "";
            return cachedToken;
        }) });
    const client = new default_api_1.DefaultApi(new configuration_1.Configuration(configurationParams), basePath, axiosApiInstance);
    function refreshAuthLogic(failedRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            // Update the cached token for future api requests
            cachedToken = (yield getAccessToken()) || "";
            // Update the headers on this request so we can retry
            if (cachedToken && cachedToken.length > 0) {
                failedRequest.response.config.headers["Authorization"] =
                    `Bearer ${cachedToken}`;
            }
            else {
                // No token exists, so this request would likely fail; don't retry.
                return Promise.reject(failedRequest);
            }
        });
    }
    axios_auth_refresh_1.default(axiosApiInstance, refreshAuthLogic, { statusCodes: [401] });
    return client;
}
exports.makeRestClient = makeRestClient;
